export const reqAPI = {
    // 2.0新接口
    unit_lesson: '/course_v2/course/path/unit/lesson',
    major_lesson: '/course_v2/course/page/mycourse/major?appVersion=3.3.2',  // ket路径页
    lesson_node: '/course_v2/course/path/lesson',
    unit_name: '/course_v2/course/vipApp/level/unit',
    user_info: '/course/app/v3/user',
    medal_info: '/course_v2/situation/encourage_info', // 勋章数量相关
    lesson_level: '/course_v2/course/path/level/v2',
    all_level: '/course_v2/course/path/level/unit/lessons',
    index_card: '/course_v2/course/index/pc/home',
    report_record: '/course_v2/situation/report_record',
    setting_data: '/course_v2/course/settingPage/setting',
    setting_data_v2: '/course_v2/course/settingPage/settingV2',
    subject_course: '/course_v2/course/page/mycourse/themeLesson',

    // 课程相关
    course_list: '/course/app/course_list',
    unit: '/course/app/v5/unit',
    lesson: '/course/app/v2/lesson',
    trial_lesson: '/course/app/trial/lesson',
    close: '/course/app/v2/lesson/home/close',
    level_lessons: '/course/app/level/v2/lessons',
    level_contents: '/course/app/level/contents',
    feedback: '/course/app/lesson/feedback',
    default_level: '/course/order/app/defaultLevel',
    open_course: '/course/order/app/openCourse',
    get_reportUrl: '/course/app/report_url',

    // baby-info 相关
    kid_names: '/course/app/kid_names',
    exam_records: '/course/app/levelExam/examRecords',
    upload_image: '/course/app/upload_image',
    add_user: '/course/app/add_user',

    // bind-weixin 相关
    bind_wx: '/course/app/bind_wx',
    unbind_wx: '/course/app/unbind_wx',

    // 课时兑换相关
    activity_usecode: '/course/app/activity/useCode',

    // FM 相关
    song_home: '/course/app/song/home',
    song_list: '/course/app/song/list',
    song_collect: '/course/app/song/collect',

    // 礼物相关
    gift_list: '/course/app/v2/gift/list',
    save_gift: '/course/app/v2/saveGift/',

    // setting 相关
    pause_button: '/course/app/pause_button',

    // 设备管理相关
    get_device: '/course_v2/user/devices', // 获取设备列表
    unbind_device: '/course_v2/user/unBindDevice', // 解绑设备

    // 设置密码相关
    set_ps_get_vCode: '/course/auth/v2/reset_pw_verify', // 获取验证码
    set_ps_check: '/course/auth/v2/reset_pw_check', // 验证验证码
    set_ps_sure: '/course/auth/v2/reset_pw', // 确认修改密码

};



// WEBPACK FOOTER //
// ./src/server/reqAPI.js